import { createFileRoute, useParams } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CourseAssessmentsView } from '@/views/assessments/course-assessments-view.tsx';

// 课程自评列表（ADR-024）。作答复用 quiz 尝试路由。
export const Route = createFileRoute('/_learner/courses_/$id/self-assessments')({
  component: SelfAssessmentsTab,
});

function SelfAssessmentsTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/self-assessments' });
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CourseAssessmentsView kind="SELF_ASSESSMENT" courseId={id} user={user} />;
}
